module.exports = __webpack_public_path__ + "media/loading_icon/loading-bar-graph-2f350141.svg";